import React, { Component } from 'react';
import { Icon } from './';
import CSSModules from 'react-css-modules';
import style from './dropdown.scss';

@CSSModules(style)
export default class Dropdown extends Component {
  state = {
    openable: true
  };

  renderList(list) {
    const items = list.map(item => {
      let sublist;
      if (item.items) {
        sublist = this.renderList(item.items);
      }

      return (
        <li>
          <a onClick={() => this.onClick(item)}>
            {item.label} {item.items ? <Icon name="caret-right" /> : null}
          </a>
          {sublist}
        </li>
      );
    });

    return <div styleName="list-wrapper"><ul>{items}</ul></div>
  }

  findObject(list, value) {
    try {
      list.forEach(item => {
        if (JSON.stringify(item.value) === JSON.stringify(value)) {
          throw item;
        } else if (item.items) {
          const result = this.findObject(item.items, value);
          if (result) throw result;
        }
      });
    } catch(e) {
      return e;
    }
  }

  onClick(item) {
    if (this.props.onClick) this.props.onClick(item);
    this.setState({ openable: false });
    setTimeout(() => this.setState({ openable: true }), 100);
  }

  render() {
    const { options = [], placeholder, value } = this.props;
    let object;

    if (value) {
      object = this.findObject(options, value);
    }

    const label = object ? object.label : placeholder;

    return (
      <div styleName={`root ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''}`}>
        <div styleName="placeholder">
          {label} <Icon name="caret-down" />
        </div>
        {this.state.openable ? this.renderList(options) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/dropdown.js